"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FEED_TYPE = exports.DELAY_BETWEEN_TYPING = void 0;
var DELAY_BETWEEN_TYPING = exports.DELAY_BETWEEN_TYPING = 7; // in sec

var FEED_TYPE = exports.FEED_TYPE = {
  ACTIVITY: 3,
  MULTICAST: 2,
  UNICAST: 1
};
var _default = exports.default = {
  FEED_TYPE
};